import { Component, OnInit } from '@angular/core';
import * as Crypto from 'crypto-js'
import { ResourcesService } from '../services/resources.service';
import { LogService } from '../services/log.service';
@Component({
  selector: 'app-watch-resource',
  templateUrl: './watch-resource.component.html',
  styleUrls: ['./watch-resource.component.css']
})
export class WatchResourceComponent implements OnInit {

  public files : String[]  = []
  public fileResource = []
  public getfile 
  fileUploadedTotal = 0;
  public uploadInterface = true
  public watchInterface = false

  public currentDisplay = 0;
  public secret = ""
  loader = false
  localStore = JSON.parse(localStorage.getItem('downloads'));
  constructor(public _resource: ResourcesService, public log: LogService) { }

  ngOnInit() {
    this.getDownloadedResources()
    // this.decryptedFile();
    this.log
      .addLog({
      action: "Access",
      component: "Watch Resources",
      details: `Access Watch Resources Component`,
    }).subscribe(data => { });
  }

  getDownloadedResources(){
    this.fileResource.length = 0;
    let getFileFromStorage = JSON.parse(localStorage.getItem('downloads'));
    if(getFileFromStorage){
      getFileFromStorage.map(file => {
        let fileSplit = file.split('-t-');
        let name = fileSplit[0];
        let title = fileSplit[0].split('.edoz')[0];
        let path = `${name}.mp4`;
        let fileObject = {path, title};
      })
    }
  }

  upload(input){
    // console.log(input.target, "TARGET");
    // this.getfile = input.target.files[0].name
    for (let i = 0; i< input.target.files.length; i++) {
      this.files.push(input.target.files[i].name);
    }
    this.fileUploadedTotal = this.files.length
  }
  
  onUpload(){
    let getFileFromStorage = JSON.parse(localStorage.getItem('downloads'));
    if(getFileFromStorage){
      localStorage.setItem('downloads',JSON.stringify([...getFileFromStorage,...this.files]))
    }else{
      localStorage.setItem('downloads',JSON.stringify([...this.files]))
    }
    this.getDownloadedResources();
    this.currentDisplay = 0;
    this.files.length = 0;
  }

  // onDecrypt(){
  //   if(this.localStore == null){
  //     localStorage.setItem('encs', JSON.stringify(this.files));
  //   }else{
  //     this.localStore.forEach(e => {
  //       this.files = [...this.files,e]
  //       localStorage.setItem('encs', JSON.stringify(this.files));
  //       // console.log(this.localStore )
  //     });
  //   }
  //   // this.decryptedFile()
  // }

  decryptedFile(){
    let gettFileFromStorage = JSON.parse(localStorage.getItem('encs'));
    if(gettFileFromStorage){
      // console.log(gettFileFromStorage, "FROM LOCALSTORAGE");
      gettFileFromStorage.forEach(value => {
          let joinWith = value.replace("___","://")
          let encJson = Crypto.AES.decrypt(JSON.stringify(joinWith),this.secret);
          let encData = Crypto.enc.Base64.stringify(Crypto.enc.Utf8.parse(encJson));
          //  localStorage.setItem('userInfo', encData);

          //restore the data to base64 first, then to utf8 data
          let decData = Crypto.enc.Base64.parse(encData).toString(Crypto.enc.Utf8);
          // Decrypt the data
          let decJson = Crypto.AES.decrypt(decData, 'aes').toString(Crypto.enc.Utf8);
          // userInfo = JSON.parse(decJson);
           let getit = decJson;
           this.fileResource.push(getit);
           if (this.fileResource !== undefined) {
            this.loader = true
             setTimeout(() => {
               this.currentDisplay = 0
              this.loader = false
            }, 4000);
           }else{
             this.currentDisplay = 1
             this.loader = false
           }
          //  console.log(this.fileResource);
      });
    }

  } 
  goBackToUpload(){
    this.currentDisplay = 1
  }
  goToWatch(){
    this.currentDisplay = 0;
    if(localStorage.getItem('downloads')){
      this.fileResource = JSON.parse(localStorage.getItem('downloads'))
    }else{
      this.fileResource.length = 0;
    }

    // console.log(this.fileResource, "RESOUCES");
  }
}
